require('./jwPlayerInternalDirective');
require('./jwPlayerController');

"use strict";

angular.module('app.player.jwPlayer.jwPlayerDirective', [
  'app.player.jwPlayer.jwPlayerInternalDirective',
  'app.player.jwPlayer.jwPlayerController'
])
    .directive('jwPlayer', [
      function () {
        return {
          restrict: 'A',
          transclude: true,
          templateUrl: 'components/player/jwPlayer/jwPlayerView.html',
          controller: 'app.player.jwPlayer.jwPlayerController',
          link: function (scope, elm, attrs) {
            scope.id = 'player-' + attrs.id;
          }
        }
      }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/player/jwPlayer/jwPlayerDirective.js